import { render, staticRenderFns } from "./DashToolbar.vue?vue&type=template&id=2ab60699&"
import script from "./DashToolbar.vue?vue&type=script&lang=js&"
export * from "./DashToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports